import { useState } from 'react';

import { Input, Modal } from '@iwoca/orion';
import { Button } from '@iwoca/orion-ui';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './LinkDENewBankAccount.module.css';
import { validateIBAN } from '../formValidation/IBANFormValidation';

type TProps = {
    onClose: () => void;
    isModalOpen: boolean;
};

export const LinkDENewBankAccountModal = ({ onClose, isModalOpen }: TProps) => {
    const intl = useIntl();
    const [newBankAccountIban, setNewBankAccountIban] = useState('');
    const [failedValidation, setFailedVaildation] = useState(false);

    const closeModal = () => {
        setNewBankAccountIban('');
        setFailedVaildation(false);
        onClose();
    };

    const onSubmitModal = (event: React.FormEvent) => {
        event.preventDefault();
        const isIbanValid = validateIBAN({ iban: newBankAccountIban });

        if (!isIbanValid) {
            setFailedVaildation(true);
            return;
        }
        closeModal();
    };

    return (
        <Modal
            headerBar={true}
            onClose={closeModal}
            isOpen={isModalOpen}
            closeIcon={true}
            data-testid="link-de-new-bank-account-modal"
            title={
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details.add_new_account_title"
                    defaultMessage="Add a new bank Account"
                />
            }
        >
            <p className={styles.inputHeader}>
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details.add_new_account_input_header"
                    defaultMessage="Enter your account’s IBAN:"
                />
            </p>
            <p className={styles.inputSubHeader}>
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details.add_new_account_input_subheader"
                    defaultMessage="Consisting of 22 characters (2-digit country code + 2-digit check number,
8-digit bank code + 10-digit account number)"
                />
            </p>
            <form onSubmit={onSubmitModal}>
                <div className={styles.ibanTextboxWrapper}>
                    <Input
                        type="text"
                        name="iban"
                        data-testid="iban-input"
                        placeholder={intl.formatMessage({
                            id: '_.funding_requirements.add_bank_details.add_new_account_placeholder_messsage',
                            defaultMessage: 'Your IBAN...'
                        })}
                        value={newBankAccountIban}
                        onChange={(e) => {
                            setNewBankAccountIban(e.target.value);
                        }}
                    />
                    {!!failedValidation && (
                        <p
                            className={styles.ibanError}
                            data-testid="iban-validation-message"
                        >
                            <FormattedMessage
                                id="_.funding_requirements.add_bank_details.add_new_account_input_error_message"
                                defaultMessage="Invalid IBAN"
                            />
                        </p>
                    )}
                </div>
                <div className={styles.buttonWrapper}>
                    <Button
                        type="submit"
                        disabled={!newBankAccountIban}
                        className={styles.button}
                    >
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.add_new_account_submit_button"
                            defaultMessage="Confirm IBAN"
                        />
                    </Button>
                </div>
            </form>
            <div className={styles.buttonWrapper}>
                <Button
                    disabled={!newBankAccountIban}
                    onClick={closeModal}
                    variant="tertiary"
                    className={styles.button}
                >
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details.add_new_account_back_button"
                        defaultMessage="Back"
                    />
                </Button>
            </div>
        </Modal>
    );
};
